import http from "../http-common"

class CelebrityAwardeesServices {
    getAllCelebrityAwardees() {
        return http.get(`/celebrity-awardees`)
    }
}


export default new CelebrityAwardeesServices();